export const SlideDetails  = {
    'startPage': {
        'slideNum': 0,
        'isSlideActive': false
    },
    'customerDetailsPrimary': { 
        'slideNum': 1, 
        'isSlideActive': false 
    },
    'consentDetailsPrimary': { 
        'slideNum': 2, 
        'isSlideActive': false 
    },
    'customerDetailsCoApp': { 
        'slideNum': 3, 
        'isSlideActive': false 
    },
    'consentDetailsCoApp': { 
        'slideNum': 4, 
        'isSlideActive': false 
    },
    'earningDetails': { 
        'slideNum': 5, 
        'isSlideActive': false 
    },
    'summary': { 
        'slideNum': 5,
         'isSlideActive': false 
    }

}